import {
  CREATE_EVENT_RULE_WITH_BENEFIT_GROUP,
  CREATE_EVENT_RULE_WITH_BENEFIT_GROUP_SUCCESS,
  CREATE_EVENT_RULE_WITH_BENEFIT_GROUP_ERROR,
  CREATE_EVENT_RULE_WITH_BENEFIT_GROUP_EMPTY,
} from './../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CreateEventRulesBenefitGroupId = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_EVENT_RULE_WITH_BENEFIT_GROUP:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CREATE_EVENT_RULE_WITH_BENEFIT_GROUP_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CREATE_EVENT_RULE_WITH_BENEFIT_GROUP_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CREATE_EVENT_RULE_WITH_BENEFIT_GROUP_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CreateEventRulesBenefitGroupId;
